// extracted by mini-css-extract-plugin
module.exports = {"select_phone_code":"InputPhone_select_phone_code__1C24U","group_phone":"InputPhone_group_phone__18QGb"};